import { RmaRequest } from 'components/ordering/rma/api/rma-request.js'
import { StatusCodeToError } from 'components/ordering/rma/api/dtos/error.js'

const EXPECTED_ERRORS = [400] as const
type ExpectedErrors = StatusCodeToError<typeof EXPECTED_ERRORS[number]>

type UpdateRmaLinePayload = {
  rmaId: string
  lineId: string
  product: number
  quantity: number
  reason: number | null
  memo: string | null
  memo2: string | null
  memo3: string | null
  originMove?: number | null
}

export class UpdateRmaLine extends RmaRequest<null, ExpectedErrors> {
  path: string
  override expectedErrors = EXPECTED_ERRORS
  override init: RequestInit

  constructor({ rmaId, lineId, product, quantity, reason, memo, memo2, memo3, originMove }: UpdateRmaLinePayload) {
    super()
    this.path = `account/rma/draft/update/${rmaId}/line/${lineId}/`
    this.init = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ product, quantity, reason, memo, memo2, memo3, originMove }),
    }
  }
}
